import { Component, OnInit } from '@angular/core';
import { VacatureService } from 'src/app/services/vacature.service';

@Component({
  selector: 'app-vacatures',
  templateUrl: './vacatures.component.html',
  styleUrls: ['./vacatures.component.sass']
})
export class VacaturesComponent implements OnInit {

  vacatures:any = [];

  constructor(private vacatureService:VacatureService) { }

  ngOnInit(): void {
    this.vacatures = [];
    this.vacatureService.getVacatures().subscribe (data => {
      for(let v of data.data) {
        let vac = this.vacatureService.populateVacature(v);
        this.vacatures.push(vac);
      }
    })
  }

}
